import { Link } from "react-router-dom";
import { Cake, CalendarDays, HeartHandshake, ScanLine, UserPlus, Users, Wallet } from "lucide-react";
import { fmtDate, rupiah } from "@/lib/api";
import { useApi, Skeleton, Stagger, Item } from "@/components/portal/ui";
import { AdminTitle } from "@/pages/admin/AdminLayout";

export default function Dashboard() {
  const { data } = useApi("/admin/stats");
  if (!data) return <Skeleton className="h-96" />;
  const stats = [
    ["Total Jemaat", data.members, Users, "bg-blue-600 text-white", "stat-members"],
    ["Jemaat Baru (bulan ini)", data.new_members, UserPlus, "bg-white", "stat-new-members"],
    ["Persembahan Bulan Ini", rupiah(data.offerings_month), Wallet, "bg-white", "stat-offerings"],
    ["Check-in 7 Hari", data.checkins_week, ScanLine, "bg-white", "stat-checkins"],
    ["Event Mendatang", data.upcoming_events, CalendarDays, "bg-white", "stat-events"],
    ["Pastoral Baru", data.pastoral_new, HeartHandshake, "bg-white", "stat-pastoral"],
    ["Ulang Tahun Minggu Ini", data.birthdays_week, Cake, "bg-indigo-600 text-white", "stat-birthdays"],
  ];
  return (
    <div data-testid="admin-dashboard">
      <AdminTitle eyebrow="Overview" title="Dashboard OPC" />
      <Stagger className="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {stats.map(([label, value, Icon, tone, id]) => (
          <Item key={label} className={`rounded-3xl p-6 border border-slate-100 shadow-sm hover:-translate-y-1 transition duration-300 ${tone}`} data-testid={id}>
            <Icon className="w-5 h-5 opacity-80" />
            <p className="mt-6 text-3xl font-black tracking-tight tabular-nums">{value}</p>
            <p className="text-sm opacity-70 mt-1">{label}</p>
          </Item>
        ))}
      </Stagger>
      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-sm border border-slate-100" data-testid="recent-members">
          <p className="font-extrabold text-slate-900">Jemaat Terbaru</p>
          <div className="mt-4 divide-y divide-slate-100">
            {data.recent_members.map((m) => (
              <div key={m.user_id} className="py-3 flex items-center gap-4">
                <span className="w-10 h-10 rounded-full bg-blue-100 text-blue-700 grid place-items-center font-black">{m.name[0]}</span>
                <div className="flex-1"><p className="font-semibold text-slate-900 text-sm">{m.name}</p><p className="text-xs text-slate-500">{m.email}</p></div>
                <div className="text-right"><p className="text-xs font-bold text-slate-900 tabular-nums">{m.nig || "—"}</p><p className="text-[11px] text-slate-500">{fmtDate(m.created_at, { day: "numeric", month: "short" })}</p></div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative rounded-3xl overflow-hidden bg-slate-900 text-white p-8 flex flex-col justify-between min-h-[260px]">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 via-slate-900/90 to-indigo-900/80" />
          <p className="relative text-4xl font-black tracking-tighter leading-[0.95]">Selamatkan<br /><span className="text-gradient">1 Jiwa Lagi.</span></p>
          <div className="relative flex flex-wrap gap-3 mt-6">
            <Link to="/admin/checkin" data-testid="dash-checkin-link" className="bg-blue-600 hover:bg-blue-500 font-bold rounded-full px-5 py-3 text-sm active:scale-95 transition">Mulai Check-in</Link>
            <Link to="/admin/offerings" data-testid="dash-offerings-link" className="bg-white/10 border border-white/20 hover:bg-white/20 font-bold rounded-full px-5 py-3 text-sm active:scale-95 transition">Hitung Persembahan</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
